import React, { useState, useEffect, useCallback } from 'react';
import { axios } from '@/lib/axios';
import { DashboardProps } from '@/containers/dashboard/Dashboard';
import {useLoadingStore} from '@/stores/loading';
import {useMessageModalStore} from '@/stores/message'
import DashboardCard from './DashboardCard';
import * as Config from '@/config'

interface SummaryData {
  name?: string;
  count: number;
}

interface Data {
  registration_count: SummaryData[];
  registration_count_by_manager_type: SummaryData[];
  road_manager: SummaryData[];
  non_road_manager: SummaryData[];
}

const DrmPf: React.FC<DashboardProps> = ({ projectId, startDate, endDate }) => {
  const setLoading = useLoadingStore(state => state.setLoading);
  const setMessage = useMessageModalStore(state => state.setMessage);

  const [summaryCustomer, setSummaryCustomer] = useState<Data>({
    registration_count: [],
    registration_count_by_manager_type: [],
    road_manager: [],
    non_road_manager: [],
  });

  const fetchData = useCallback(async (projectCategoryId: number): Promise<Data> => {
    const response = await axios.get(`/api/v1/dashboard/customerSummary`, {
      params: {
        project_id: projectId,
        project_category_id: projectCategoryId,
        start_date: startDate,
        end_date: endDate,
      },
    });
    return response.data.summary; // ← Data型のオブジェクト
  }, [projectId, startDate, endDate]);

  useEffect(() => {
    const loadAllData = async () => {
      setLoading(true);
      try {
        const customerData = await fetchData(Config.PROJECT_CATEGORY_ID_CUSTOMER_LIST);
        setSummaryCustomer(customerData);
      } catch (err) {
        setMessage(Config.MESSAGE_NO_E39);
      } finally {
        setLoading(false);
      }
    };

    loadAllData();
  }, [fetchData, setLoading]);

  return (
    <div className="dashboard-grid">
      {summaryCustomer.registration_count.length > 0 && (
        <DashboardCard title='顧客全体の登録数'>
          <table>
            <tbody>
              {summaryCustomer.registration_count.map((summary, index) => (
                <tr key={`summary_customer_${index}`}>
                  <td>{`${summary.count}件`}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </DashboardCard>
      )}

      {summaryCustomer.registration_count_by_manager_type.length > 0 && (
        <DashboardCard title='道路管理者区分毎の登録数'>
          <table>
            <tbody>
              {summaryCustomer.registration_count_by_manager_type.map((summary, index) => (
                <tr key={`summary_customer_type_${index}`}>
                  <td>{summary.name}</td>
                  <td>{`${summary.count}件`}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </DashboardCard>
      )}

      {summaryCustomer.road_manager.length > 0 && (
        <DashboardCard title='道路管理者'>
          <table>
            <tbody>
              {summaryCustomer.road_manager.map((summary, index) => (
                <tr key={`summary_customer_kubun1_${index}`}>
                  <td>{summary.name}</td>
                  <td>{`${summary.count}件`}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </DashboardCard>
      )}

      {summaryCustomer.non_road_manager.length > 0 && (
        <DashboardCard title='道路管理者以外'>
          <table>
            <tbody>
              {summaryCustomer.non_road_manager.map((summary, index) => (
                <tr key={`summary_customer_kubun2_${index}`}>
                  <td>{summary.name}</td>
                  <td>{`${summary.count}件`}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </DashboardCard>
      )}
    </div>
  );
};

export default DrmPf;